import { Component } from '@angular/core';

@Component({
  selector: 'app-ngb-popover-demo',
  templateUrl: './popover-demo.component.html',
})
export class NgbPopoverDemoComponent {}

export class NgbdPopoverBasic {}
